import { render, staticRenderFns } from "./ScheduledEarningsandDeductions.vue?vue&type=template&id=89e40f7c&scoped=true"
import script from "./ScheduledEarningsandDeductions.vue?vue&type=script&lang=js"
export * from "./ScheduledEarningsandDeductions.vue?vue&type=script&lang=js"
import style0 from "./ScheduledEarningsandDeductions.vue?vue&type=style&index=0&id=89e40f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e40f7c",
  null
  
)

export default component.exports